/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_invite_page_title = /** @type {(inputs: { name: NonNullable<unknown>, orgName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.name} Estás a un paso de unirte a ${i.orgName}`
};

const en_invite_page_title = /** @type {(inputs: { name: NonNullable<unknown>, orgName: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.name} You're one step away from joining ${i.orgName}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown>, orgName: NonNullable<unknown> }} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const invite_page_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.invite_page_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("invite_page_title", locale)
	if (locale === "es") return es_invite_page_title(inputs)
	return en_invite_page_title(inputs)
};
export { invite_page_title as "invite.page.title" }